// authConfig.js
export function createMsalConfig(clientId, tenantId) {
  return {
    auth: {
      clientId: clientId,
      authority: `https://login.microsoftonline.com/${tenantId}`,
      redirectUri: "http://localhost:3000", // หรือ path เฉพาะถ้าต้องการ
    },
    cache: {
      cacheLocation: "cookiesStorage",
      storeAuthStateInCookie: false,
    },
  };
}

export const loginRequest = {
  scopes: ["User.Read"],
};